//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tlsHLRouteSource: {
      type: Object,
      default: null
    }
  },
  computed: {
    children: function () {
      return this.tlsHLRouteSource && this.tlsHLRouteSource.compound && this.tlsHLRouteSource.compound[0] && this.tlsHLRouteSource.compound[0].children
    },
    tlsAll: function () {
      return this.children && this.children.find(children => children.type === 'tlsAll')
    },
    tlsGk: function () {
      return this.children && this.children.find(children => children.type === 'tlsGk')
    }
  }
}
